import { DefaultSuccessDialog } from '@/packages/courses/pages/registration/components/default-success-dialog';
import { InstructionDialog } from '@/packages/courses/pages/registration/components/instruction-dialog';
import { SuccessDialog } from '@/packages/courses/pages/registration/components/success-dialog';
import type { InstitutionSubscriptionConfig } from '@/data/catalog/offer/interfaces';

interface NextStepsDialogProps {
  onClose: () => void;
  config?: InstitutionSubscriptionConfig | null;
  institutionName?: string;
  email?: string;
  phone?: string;
}

export const NextStepsDialog = ({
  onClose,
  config,
  institutionName,
  email,
  phone,
}: NextStepsDialogProps) => {
  // External subscription action: the institution provides a link to complete
  // the enrollment on their own site.
  if (config?.link) {
    return (
      <InstructionDialog
        onClose={onClose}
        institutionName={institutionName}
        config={config}
      />
    );
  }

  // Non-external instruction: the institution reaches out by e-mail.
  if (config) {
    return (
      <SuccessDialog
        onClose={onClose}
        institutionName={institutionName}
        email={email ?? ''}
      />
    );
  }

  // Default: no specific instruction, contact happens via the institution's
  // own process (e-mail and/or WhatsApp).
  return (
    <DefaultSuccessDialog
      onClose={onClose}
      institutionName={institutionName}
      email={email}
      phone={phone}
    />
  );
};
